import { Pipe, PipeTransform } from '@angular/core';
import { IMenuItem } from '@app/xenial-ux/interfaces';

@Pipe({
  name: 'searchMenuItems',
})
export class SearchMenuItemsPipe implements PipeTransform {
  public transform(items: IMenuItem[], searchText: string): IMenuItem[] {
    if (!searchText) {
      return items;
    }
    const search = (searchItems: IMenuItem[]): any[] => {
      let ret: IMenuItem[] = [];
      searchItems.forEach((searchItem) => {
        if (Array.isArray(searchItem.subItemsArray)) {
          ret = ret.concat(search(searchItem.subItemsArray));
        } else if (
          searchItem.title.toLowerCase().indexOf(searchText.toLowerCase()) > -1
        ) {
          ret.push(searchItem);
        }
      });

      return ret;
    };

    return search(items);
  }
}
